import { useAccountPicker } from '../../account-picker/hooks/use-account-picker';
var COPY_BOARD_INFO_ENUM = {
  COPY_BOARD_ACCOUNT_ID: 'copyBoardAccountId',
  COPY_TEMPLATE_META_ID: 'copyTemplateMetaId'
};

var setCookie = function setCookie(name, value, days) {
  var expires = '';

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }

  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

function saveInfoAndOpenApplication(options) {
  var selectedTemplate = options.selectedTemplate,
      accountId = options.accountId,
      workspaceKey = options.workspaceKey,
      onTemplateCopy = options.onTemplateCopy;
  var metadataId = selectedTemplate.metadataId,
      entryId = selectedTemplate.entryId;

  if (!metadataId) {
    return;
  }

  setCookie(COPY_BOARD_INFO_ENUM.COPY_TEMPLATE_META_ID, metadataId, 30);

  if (accountId) {
    setCookie(COPY_BOARD_INFO_ENUM.COPY_BOARD_ACCOUNT_ID, accountId, 30);
  }

  if (entryId && onTemplateCopy && typeof onTemplateCopy === 'function') {
    onTemplateCopy(entryId);
  }

  window.location.href = "".concat(workspaceKey ? "/s/".concat(workspaceKey) : '', "/app/");
}

function useTemplate(selectedTemplate, setSelectedTemplate, onTemplateCopy) {
  var callback = function callback(accountId, workspaceKey, onTemplateCopy) {
    return saveInfoAndOpenApplication({
      selectedTemplate: selectedTemplate,
      accountId: accountId,
      workspaceKey: workspaceKey,
      onTemplateCopy: onTemplateCopy
    });
  };

  return useAccountPicker({
    onAccountCancel: function onAccountCancel() {
      return setSelectedTemplate({
        metadataId: null
      });
    },
    onAccountError: function onAccountError() {
      return saveInfoAndOpenApplication({
        selectedTemplate: selectedTemplate,
        onTemplateCopy: onTemplateCopy
      });
    },
    onAccountLoaded: callback,
    onAccountSubmitted: callback
  });
}

export default useTemplate;